import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem; 
  height: 5rem; 
  border-radius: 50%;
  padding: 0.125rem 0.1875rem; 
  color: #442404;
  background: #FFCF00;
  position: absolute;
  bottom: -0.875rem; 
  left: 0.875rem; 
  border: 0.9375rem solid white; 
`;

export const StyledIcon = styled.span`
  font-size: 1.5rem; 
  font-weight: bold; 
`;